import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
export class AmpMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    //@ts-ignore
    return params.interpolateParams?.fallback != null ? params.interpolateParams.fallback : params.key;
  }
}
